import { Icon, IconButton, IconNames } from '@dixa/lib-shared-habla';
import { colors } from '@dixa/lib-shared-tokens';
import classnames from 'classnames';
import * as React from 'react';

import styles from './flowNode.module.scss';

export const flowNodeColor = {
  default: '#8294B0',
  green: colors.green['500'],
  red: colors.red['500'],
  orange: colors.orange['500'],
  purple: colors.purple['500'],
  blue: colors.blue['400'],
};

export type FlowNodeColorValue =
  (typeof flowNodeColor)[keyof typeof flowNodeColor];

export type Props = {
  /** Extra classnames */
  className?: string;
  color?: (typeof flowNodeColor)[keyof typeof flowNodeColor];
  icon?: IconNames;
  label: string;
  text?: string | React.ReactNode;
  onEdit?: () => void;
  style?: React.CSSProperties;
};

export class FlowNode extends React.PureComponent<Props> {
  static defaultProps: {
    /** Color */
    color: string;
  };

  static dimensions: {
    h: number;
    w: number;
  };

  stopPropagation = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ): void => {
    e.stopPropagation();
  };

  render() {
    const { className, icon, color, label, text, onEdit, style } = this.props;

    const rootClass = classnames(
      {
        [styles.root]: true,
        [styles.rootNoText]: !text,
      },
      className,
    );

    const hasAction = !!onEdit;

    return (
      <div className={rootClass} style={style}>
        <div className={styles.label}>
          <div
            className={styles.labelColor}
            style={{ backgroundColor: color }}
          />
          {icon && (
            <Icon
              name={icon}
              className={classnames(styles.labelIcon, 'icon-vertical-fix')}
            />
          )}
          <span className={styles.labelName}>{label}</span>
          {hasAction && (
            <div className={styles.labelActions}>
              <IconButton
                variant="tertiary"
                icon="pen"
                className={styles.labelAction}
                onClick={onEdit}
                onMouseDown={this.stopPropagation}
              />
            </div>
          )}
        </div>
        {!!text && <div className={styles.text}>{text}</div>}
      </div>
    );
  }
}

FlowNode.defaultProps = {
  color: flowNodeColor.default,
};

FlowNode.dimensions = {
  h: 64,
  w: 250,
};
